var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"choosep"},[_vm._v("选择讲解语言")]),_vm._v(" "),_c('div',{staticClass:"listboxf"},_vm._l((_vm.nums),function(data,index){return _c('router-link',{key:index,attrs:{"to":{ name:'Home',query: { a: data}}}},[_c('span',[_vm._v(_vm._s(data))]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-back"})])}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-510244a9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/choose.vue
// module id = null
// module chunks = 